(function ($) {
    function adjustColumns() {
        if (!Modernizr.flexbox) {
            $('.same-height-children').sameHeight();
        }
    }

    if (typeof Modernizr !== typeof undefined) {
        $(function () {
            adjustColumns();
        });
    }
})(jQuery);